import React from 'react';
import { Table } from 'semantic-ui-react';
import RowAddColumn from '@/components/table/RowAddColumn';
import TableWrapper from '@/components/table/TableWrapper';
import UnsortedColumn from '@/components/table/UnsortedColumn';
import VocabularyRoleActionRows from './VocabularyRoleActionRows';

const VocabularyRoleActionTable = ({
  activeRoleActionUUID,
  onActionSelected,
  onAddClicked,
  onDeleteClicked,
  roleActions,
  updateErrors,
}) => (
  <TableWrapper celled className="absolute max-h-full w-100 overflow-x-hidden" sticky selectable>
    <Table.Header fullWidth>
      <Table.Row>
        <UnsortedColumn columnId="name" />
        <UnsortedColumn columnId="title" />
        <RowAddColumn entity="vocabulary.role.action" onClick={onAddClicked} />
      </Table.Row>
    </Table.Header>
    <Table.Body>
      <VocabularyRoleActionRows
        activeRoleActionUUID={activeRoleActionUUID}
        roleActions={roleActions}
        onActionSelected={onActionSelected}
        onDeleteClicked={onDeleteClicked}
        updateErrors={updateErrors}
      />
    </Table.Body>
  </TableWrapper>
);

export default VocabularyRoleActionTable;
